const oktaClientId = process.env.REACT_APP_OKTA_CLIENT_ID;
const redirectUri = process.env.REACT_APP_REDIRECT_URL;
const authorizeEndpoint = process.env.REACT_APP_AUTHORIZE_ENDPOINT;
const oktaDomain = process.env.REACT_APP_OKTA_DOMAIN;

const oktaClientConfig = {
  url: `https://${oktaDomain}`,
  issuer: `https://${oktaDomain}`,
  clientId: oktaClientId,
  redirectUri,
  responseMode: 'fragment'
};

const okta = {
  oktaClientId,
  redirectUri,
  authorizeEndpoint,
  oktaClientConfig,
  oktaDomain,
  scopes: ['openid', 'email', 'profile']
};

export default okta;